import { useMemo } from "react";

import {
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import { Button, Typography, User01Icon } from "components";
import { gray, success, warning } from "configs/colors";

const ApprovalProgressStepConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 20,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: gray[700],
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: gray[700],
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: gray[200],
    borderRadius: 1,
  },
}));

const ApprovalProgressStepIcon = (props: StepIconProps) => {
  const { active, completed } = props;

  const stepColor = useMemo(() => {
    if (completed)
      return {
        background: success[100],
        color: success[600],
      };
    if (active)
      return {
        background: warning[100],
        color: warning[600],
      };
    return {
      background: gray[100],
      color: gray[600],
    };
  }, [active, completed]);

  return (
    <Button
      size="icon-md"
      sx={{ ...stepColor, borderRadius: "50%", pointerEvents: "none" }}
    >
      <User01Icon color="inherit" fontSize="small" />
    </Button>
  );
};

interface Props {
  activeStep?: number;
  data?: Array<string>;
}

export const IndexComponent: React.FC<Props> = ({ activeStep, data }) =>
  !data || data.length === 0 ? null : (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ApprovalProgressStepConnector />}
    >
      {data.map((i, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Step key={index}>
          <StepLabel StepIconComponent={ApprovalProgressStepIcon}>
            <Typography type="TextSM" fontWeight={600}>
              {i}
            </Typography>
            <Typography type="TextSM">Step {index + 1}</Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );

export default IndexComponent;
